<nav class="breadcrumb-nav" aria-label="breadcrumb">
  <ol class="breadcrumb">
    @for (crumb of crumbs$ | async; track crumb.label; let last = $last; let first = $first) {
      <li class="breadcrumb-item" [class.active]="last" [class.has-suffix]="!!crumb.suffix">
        @if (!first) {
          <span class="breadcrumb-separator" aria-hidden="true"></span>
        }
        @if (crumb.url && !last) {
          <a [routerLink]="crumb.url">{{ crumb.label }}</a>
        } @else {
          <span class="breadcrumb-leaf">
            <span class="breadcrumb-label">{{ crumb.label }}</span>

            @if (crumb.suffix) {
              <span class="breadcrumb-suffix-wrapper">
                <span class="breadcrumb-suffix-group">
                  <span class="breadcrumb-suffix">{{ crumb.suffix }}</span>
                  @if (crumb.copyValue) {
                    <app-copy-to-clipboard
                      [value]="crumb.copyValue"
                      [isSmallSize]="true"
                      copyToolTip="COMMON.COPY_REFERENCE_NUMBER"
                      copiedToolTip="COMMON.COPIED_REFERENCE_NUMBER">
                    </app-copy-to-clipboard>
                  }
                </span>
              </span>
            }
          </span>
        }
      </li>
    }
  </ol>
</nav>
